export default {
  FormName: "Наименование формы",
  ShortFormName: "Короткое наименование формы",
};
